import React from 'react';
import { sprintf } from 'sprintf';

import { SpinnerWithLabel } from 'components/Spinner';
import { formatPrice } from 'services/stringFormating';

import { ButtonSlideshow } from './ButtonSlideshow';

export type ConfirmFormStates =
  | 'confirm-waiting-user'
  | 'confirm-submitting-bid'
  | 'confirm-success';

type Props = {
  state: ConfirmFormStates;
  priceCents: number;
  creditCardLast4?: string;
  onSubmit: (priceCents: number) => void;
  onCancel: () => void;
  onRequestChangeCard: (last4: string) => void;
};

export const ConfirmForm: React.FC<Props> = ({
  state,
  priceCents,
  creditCardLast4,
  onSubmit,
  onCancel,
  onRequestChangeCard,
}) => {
  return (
    <form
      className='mb-0'
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit(priceCents);
      }}
    >
      <p className='mb-2'>
        Placing a bid we will reserve {formatPrice(priceCents, 'USD')} on your credit card ending in{' '}
        <code className='code d-inline-block'>{creditCardLast4}</code> [
        <a
          onClick={(event) => {
            event.preventDefault();
            creditCardLast4 && onRequestChangeCard(creditCardLast4);
          }}
          href='#'
          className='color-current link-border'
        >
          change card
        </a>
        ]. Your funds will be released if you are outbid. Are you sure you want to make this bid?
      </p>

      <ButtonSlideshow state={state}>
        {state === 'confirm-waiting-user' ? (
          <>
            <button type='submit' className='btn bg-black'>
              Bid
            </button>
            <button className='btn btn--blended' onClick={onCancel}>
              Cancel
            </button>
          </>
        ) : null}
        {state === 'confirm-submitting-bid' ? (
          <SpinnerWithLabel>Submitting your bid...</SpinnerWithLabel>
        ) : null}
        {state === 'confirm-success' ? (
          <div className='key-value key-value__value'>
            <span className='icon-checkmark text-success mr-mini' />
            Success, you are the highest bidder!
          </div>
        ) : null}
      </ButtonSlideshow>
    </form>
  );
};
